/**
 * Portuguese profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Portuguese
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 218
 */

export const PT = {
  "metadata": {
    "name": "Portuguese",
    "code": "pt",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 218
  },
  "words": [
    {
      "word": "caralho",
      "severity": 3,
      "categories": [
        "anatomical",
        "general",
        "emphatic"
      ],
      "variations": [
        "carai",
        "crl",
        "c@ralho",
        "kar@lho",
        "caraho"
      ],
      "case_sensitive": false,
      "context_notes": "Most versatile Portuguese swear word, used as intensifier, particularly in Brazil",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "moderate"
      },
      "formality_level": "casual_acceptable_informal"
    },
    {
      "word": "porra",
      "severity": 2,
      "categories": [
        "sexual",
        "general",
        "scatological"
      ],
      "variations": [
        "prr",
        "p0rra",
        "p*rra",
        "poxa",
        "nossa"
      ],
      "case_sensitive": false,
      "context_notes": "Very common in Brazilian Portuguese, less offensive than anatomical meaning suggests",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "less_common",
        "pt_AO": "common",
        "pt_MZ": "moderate"
      },
      "formality_level": "mild_general_usage"
    },
    {
      "word": "merda",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "mrd",
        "m3rda",
        "m*rda",
        "mierda",
        "droga"
      ],
      "case_sensitive": false,
      "context_notes": "Universal Portuguese expletive, roughly equivalent to English 'shit'",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "foder",
      "severity": 3,
      "categories": [
        "sexual",
        "violence",
        "general"
      ],
      "variations": [
        "fder",
        "f0der",
        "fuder",
        "ferrar",
        "se foder"
      ],
      "case_sensitive": false,
      "context_notes": "Strong verb meaning 'to fuck', very common in expressions like 'vai se foder'",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "puta",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "pt",
        "p*ta",
        "put@",
        "pvta",
        "prostituta"
      ],
      "case_sensitive": false,
      "context_notes": "Strong derogatory term for women, also used as intensifier 'puta merda'",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "filho da puta",
      "severity": 4,
      "categories": [
        "derogatory",
        "sexual",
        "family_insult"
      ],
      "variations": [
        "fdp",
        "filhodaputa",
        "hijo de puta",
        "f.d.p.",
        "fdputx"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a bitch, extremely offensive compound insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "rare"
      },
      "formality_level": "severe_offense"
    },
    {
      "word": "cu",
      "severity": 2,
      "categories": [
        "anatomical",
        "general"
      ],
      "variations": [
        "c*",
        "kyu",
        "c+",
        "cu**",
        "bumbum"
      ],
      "case_sensitive": false,
      "context_notes": "Buttocks/anus, very common in Brazilian expressions, less taboo than English equivalent",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "less_common",
        "pt_AO": "common",
        "pt_MZ": "moderate"
      },
      "formality_level": "mild_to_moderate"
    },
    {
      "word": "buceta",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "bct",
        "bc",
        "b*ceta",
        "bucet@",
        "xota"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia, vulgar but commonly used in Brazilian Portuguese",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "less_common",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "cacete",
      "severity": 2,
      "categories": [
        "anatomical",
        "general",
        "emphatic"
      ],
      "variations": [
        "cct",
        "cacet*",
        "c@cete",
        "que cacete"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia reference but often used as general exclamation",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "pinto",
      "severity": 1,
      "categories": [
        "anatomical",
        "childish"
      ],
      "variations": [
        "pnt",
        "p1nto",
        "pintinho",
        "pipi"
      ],
      "case_sensitive": false,
      "context_notes": "Childish term for penis, relatively mild",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_childish"
    },
    {
      "word": "viado",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory",
        "male_specific"
      ],
      "variations": [
        "vdd",
        "vi@do",
        "veado",
        "bixa",
        "gay"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur, very offensive when used against LGBTQ+ individuals",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common_but_declining",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "bicha",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "bch",
        "bich@",
        "b1cha",
        "bixa"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur, particularly offensive in Portuguese context",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "cornudo",
      "severity": 2,
      "categories": [
        "derogatory",
        "relationship",
        "male_specific"
      ],
      "variations": [
        "corno",
        "crn",
        "c0rno",
        "chifrudo"
      ],
      "case_sensitive": false,
      "context_notes": "Cuckold insult, implies romantic betrayal, culturally specific shame",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "otário",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "otário",
        "ot@rio",
        "ot4rio",
        "trouxa"
      ],
      "case_sensitive": false,
      "context_notes": "Fool, sucker, very common Brazilian insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "babaca",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "bbc",
        "bab@ca",
        "babak@",
        "idiota"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot, fool, common Brazilian insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "sacana",
      "severity": 2,
      "categories": [
        "derogatory",
        "general",
        "sexual_undertone"
      ],
      "variations": [
        "scn",
        "sac@na",
        "sacana",
        "safado"
      ],
      "case_sensitive": false,
      "context_notes": "Rascal, can be playful or insulting depending on context",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "mild_to_moderate"
    },
    {
      "word": "desgraça",
      "severity": 2,
      "categories": [
        "derogatory",
        "general",
        "religious"
      ],
      "variations": [
        "desgraça",
        "desgr@ça",
        "desgraca"
      ],
      "case_sensitive": false,
      "context_notes": "Disgrace, wretch, can be religious curse",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "peste",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild"
      ],
      "variations": [
        "pst",
        "p3ste",
        "pestinha"
      ],
      "case_sensitive": false,
      "context_notes": "Pest, mild insult often used for children",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "piranha",
      "severity": 3,
      "categories": [
        "derogatory",
        "female_specific",
        "sexual"
      ],
      "variations": [
        "prnh",
        "pir@nha",
        "piranhas"
      ],
      "case_sensitive": false,
      "context_notes": "Slut, promiscuous woman insult, very offensive",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "vagabundo",
      "severity": 2,
      "categories": [
        "derogatory",
        "socioeconomic",
        "general"
      ],
      "variations": [
        "vgb",
        "vagabund0",
        "vag@bundo"
      ],
      "case_sensitive": false,
      "context_notes": "Vagrant, worthless person, socioeconomic insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "aborto",
      "severity": 3,
      "categories": [
        "derogatory",
        "religious"
      ],
      "variations": [
        "ab0rto",
        "@borto"
      ],
      "case_sensitive": false,
      "context_notes": "Abortion used as insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "arrombado",
      "severity": 3,
      "categories": [
        "derogatory",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "arrombada",
        "@rrombado",
        "arromb@do"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole, literally 'broken open' - BR very common",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "less_common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "arregaçado",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "arregaçada",
        "arregac@do"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked up, messed up",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "bagaceira",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "bag@ceira"
      ],
      "case_sensitive": false,
      "context_notes": "Mess, brothel",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "baitola",
      "severity": 4,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "b@itola"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - PT specific homophobic slur",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "baleia",
      "severity": 2,
      "categories": [
        "derogatory",
        "body_shaming"
      ],
      "variations": [
        "bal3ia"
      ],
      "case_sensitive": false,
      "context_notes": "Whale - fat person insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "bastardo",
      "severity": 2,
      "categories": [
        "derogatory",
        "family_insult"
      ],
      "variations": [
        "bastarda",
        "b@stardo"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "boceta",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "boc3ta",
        "boc@ta"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy/cunt - BR variant, very common",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "bosta",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "b0sta",
        "b*sta"
      ],
      "case_sensitive": false,
      "context_notes": "Shit, crap - very common casual usage",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_to_moderate"
    },
    {
      "word": "boçal",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "boç@l"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid, dumb",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "boquete",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "boqu3te"
      ],
      "case_sensitive": false,
      "context_notes": "Blowjob - BR common term",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "boqueteira",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "boquet3ira"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker - feminine, derogatory",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "broxa",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "br0xa"
      ],
      "case_sensitive": false,
      "context_notes": "Impotent man",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "bufa",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "buf@"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian - derogatory",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "burro",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "burra",
        "burr0",
        "b4rro"
      ],
      "case_sensitive": false,
      "context_notes": "Donkey, stupid person",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "busseta",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "buss3ta"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - variant",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "cabrão",
      "severity": 3,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "cabrona",
        "cabr@o"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard, asshole - PT signature curse",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "cabrito",
      "severity": 2,
      "categories": [
        "derogatory",
        "relationship"
      ],
      "variations": [
        "c@brito"
      ],
      "case_sensitive": false,
      "context_notes": "Goat, cuckold - PT",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "cagalhão",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "cag@lhão"
      ],
      "case_sensitive": false,
      "context_notes": "Big shit",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "cagar",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "c@gar",
        "kagar"
      ],
      "case_sensitive": false,
      "context_notes": "To shit",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "cagão",
      "severity": 2,
      "categories": [
        "derogatory",
        "scatological"
      ],
      "variations": [
        "cagona",
        "cag@o"
      ],
      "case_sensitive": false,
      "context_notes": "Coward, chicken shit",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "cambada",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "camb@da"
      ],
      "case_sensitive": false,
      "context_notes": "Bunch of - always negative",
      "target_type": "group",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "chata",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild"
      ],
      "variations": [
        "chato",
        "ch@ta"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying person",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "chochota",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "chochot@"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - PT specific",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "chifrudo",
      "severity": 2,
      "categories": [
        "derogatory",
        "relationship"
      ],
      "variations": [
        "chifruda",
        "chifrud0"
      ],
      "case_sensitive": false,
      "context_notes": "Cuckolded person - literally 'horned'",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "chochinho",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "chochin0"
      ],
      "case_sensitive": false,
      "context_notes": "Little pussy - diminutive",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "chucha",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "chuch@"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - regional",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "chuchumeco",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "chuchum3co"
      ],
      "case_sensitive": false,
      "context_notes": "Insignificant person",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "chupar",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "chup@r",
        "chupar"
      ],
      "case_sensitive": false,
      "context_notes": "To suck - sexual context",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "chupa-pilas",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "chupa pilas"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker - PT",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "clitóris",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual"
      ],
      "variations": [
        "clitoris"
      ],
      "case_sensitive": false,
      "context_notes": "Clitoris",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "cocaína",
      "severity": 2,
      "categories": [
        "drug_reference"
      ],
      "variations": [
        "coca",
        "c0caina"
      ],
      "case_sensitive": false,
      "context_notes": "Cocaine",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "coito",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "c0ito"
      ],
      "case_sensitive": false,
      "context_notes": "Coitus, intercourse",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "colhão",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "colhões",
        "colh@o"
      ],
      "case_sensitive": false,
      "context_notes": "Testicle(s) - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "comer",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "com3r"
      ],
      "case_sensitive": false,
      "context_notes": "To eat / to fuck - BR very common double meaning",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "rare",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "comedor",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory",
        "male_specific"
      ],
      "variations": [
        "com3dor"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker, stud - BR",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "cona",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "c0na",
        "kon@"
      ],
      "case_sensitive": false,
      "context_notes": "Cunt - PT primary term",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "extremely_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "consolo",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "cons0lo"
      ],
      "case_sensitive": false,
      "context_notes": "Dildo, consolation",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "corno",
      "severity": 2,
      "categories": [
        "derogatory",
        "relationship",
        "male_specific"
      ],
      "variations": [
        "corna",
        "c0rno"
      ],
      "case_sensitive": false,
      "context_notes": "Cuckold - BR cultural phenomenon, extremely common",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "crioulo",
      "severity": 4,
      "categories": [
        "racial_slur",
        "derogatory"
      ],
      "variations": [
        "crioula",
        "cri0ulo"
      ],
      "case_sensitive": false,
      "context_notes": "N-word - extremely racist",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "cuzão",
      "severity": 3,
      "categories": [
        "anatomical",
        "derogatory"
      ],
      "variations": [
        "cuzana",
        "cuz@o"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole - augmentative, very offensive",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "dar o cu",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "dar o c*"
      ],
      "case_sensitive": false,
      "context_notes": "Give ass, to bottom - sexual phrase",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "dar o rabo",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "dar o rab0"
      ],
      "case_sensitive": false,
      "context_notes": "Give tail, to bottom",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "débil mental",
      "severity": 3,
      "categories": [
        "derogatory",
        "ableist",
        "intelligence"
      ],
      "variations": [
        "debil mental"
      ],
      "case_sensitive": false,
      "context_notes": "Mental retard - ableist slur",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "desgraçado",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "desgraçada",
        "desgraç@do"
      ],
      "case_sensitive": false,
      "context_notes": "Wretch, scumbag",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "doido",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild"
      ],
      "variations": [
        "doida",
        "d0ido"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy, insane - can be playful",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "enrabar",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "enrab@r"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in the ass",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "escroto",
      "severity": 3,
      "categories": [
        "anatomical",
        "derogatory"
      ],
      "variations": [
        "escr0to"
      ],
      "case_sensitive": false,
      "context_notes": "Scrotum, scumbag",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "estúpido",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "estúpida",
        "estupid0"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "estrume",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "estrum3"
      ],
      "case_sensitive": false,
      "context_notes": "Manure, shit",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "fanchono",
      "severity": 4,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "f@nchono"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - PT old term",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "filha da puta",
      "severity": 4,
      "categories": [
        "derogatory",
        "sexual",
        "family_insult",
        "female_specific"
      ],
      "variations": [
        "filha d@ puta"
      ],
      "case_sensitive": false,
      "context_notes": "Daughter of a whore",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "rare"
      },
      "formality_level": "severe_offense"
    },
    {
      "word": "filho da égua",
      "severity": 3,
      "categories": [
        "derogatory",
        "family_insult"
      ],
      "variations": [
        "filho d@ égua"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a mare",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "filho da mãe",
      "severity": 3,
      "categories": [
        "derogatory",
        "family_insult"
      ],
      "variations": [
        "filho d@ mãe"
      ],
      "case_sensitive": false,
      "context_notes": "Son of the mother - severe insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "foda",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "f0da"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck, difficult - BR extremely common",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "foda-se",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "fodase",
        "fod@-se"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck it, fuck off - very common",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "fodão",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "fod@o"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking awesome, badass - can be positive in BR",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "mild_to_moderate"
    },
    {
      "word": "fodido",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "fodida",
        "f0dido"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked, screwed",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "fuça",
      "severity": 2,
      "categories": [
        "derogatory",
        "body_shaming"
      ],
      "variations": [
        "fuç@"
      ],
      "case_sensitive": false,
      "context_notes": "Snout, ugly face",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "gaja",
      "severity": 1,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "g@ja"
      ],
      "case_sensitive": false,
      "context_notes": "Chick, broad - PT",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "galinha",
      "severity": 2,
      "categories": [
        "derogatory",
        "female_specific",
        "sexual"
      ],
      "variations": [
        "galinx@"
      ],
      "case_sensitive": false,
      "context_notes": "Chicken, slut",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "gordo",
      "severity": 2,
      "categories": [
        "derogatory",
        "body_shaming"
      ],
      "variations": [
        "gorda",
        "g0rdo"
      ],
      "case_sensitive": false,
      "context_notes": "Fat - insulting when used as insult",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "gozar",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "g0zar"
      ],
      "case_sensitive": false,
      "context_notes": "To cum, to mock - double meaning",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "grelo",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "gr3lo"
      ],
      "case_sensitive": false,
      "context_notes": "Clit - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "idiota",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "idi0ta"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "imbecil",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "imbec1l"
      ],
      "case_sensitive": false,
      "context_notes": "Imbecile",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "lascado",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "lascada",
        "lasc@do"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked, screwed",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "macaco",
      "severity": 4,
      "categories": [
        "racial_slur",
        "derogatory"
      ],
      "variations": [
        "macaca",
        "mac@co"
      ],
      "case_sensitive": false,
      "context_notes": "Monkey - extremely racist slur against Black people",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "mamar",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "m@mar"
      ],
      "case_sensitive": false,
      "context_notes": "To suckle, to suck dick",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "merdinha",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "merdinx@"
      ],
      "case_sensitive": false,
      "context_notes": "Little shit - diminutive",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "merdoso",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "merdosa",
        "merd0so"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty person",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "mijar",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mij@r"
      ],
      "case_sensitive": false,
      "context_notes": "To piss",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "mijo",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mij0"
      ],
      "case_sensitive": false,
      "context_notes": "Piss, urine",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "nabo",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "n@bo"
      ],
      "case_sensitive": false,
      "context_notes": "Turnip, dick",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "nojento",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "nojenta",
        "noj3nto"
      ],
      "case_sensitive": false,
      "context_notes": "Disgusting, filthy",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "ordinário",
      "severity": 2,
      "categories": [
        "derogatory",
        "socioeconomic"
      ],
      "variations": [
        "ordinária",
        "ordin@rio"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar, low-class",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "paneleiro",
      "severity": 4,
      "categories": [
        "lgbtq_slur",
        "derogatory",
        "male_specific"
      ],
      "variations": [
        "panel3iro"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - PT specific",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "panilas",
      "severity": 4,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "panil@s"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - PT",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "moderate",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "parvo",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "parva",
        "p@rvo"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid - PT",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "pau",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "p@u"
      ],
      "case_sensitive": false,
      "context_notes": "Dick, stick - BR very common",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "peidar",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "peid@r"
      ],
      "case_sensitive": false,
      "context_notes": "To fart",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "peido",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "peid0"
      ],
      "case_sensitive": false,
      "context_notes": "Fart",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_offense"
    },
    {
      "word": "pica",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "pic@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - BR regional",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "piça",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "piç@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "pila",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "pil@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "piroca",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "pir0ca"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - BR",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "piru",
      "severity": 2,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "pir4"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - BR slang",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "pita",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "pit@"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "puta merda",
      "severity": 3,
      "categories": [
        "sexual",
        "scatological",
        "general"
      ],
      "variations": [
        "puta m3rda",
        "puta de merda"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking shit - very common BR/PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "puta que pariu",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "puta q pariu"
      ],
      "case_sensitive": false,
      "context_notes": "Holy shit - literally 'whore who birthed'",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "putão",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "put@o"
      ],
      "case_sensitive": false,
      "context_notes": "Male whore, big whore",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "putaria",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "put@ria"
      ],
      "case_sensitive": false,
      "context_notes": "Whoring, debauchery",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "quenga",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "qu3nga"
      ],
      "case_sensitive": false,
      "context_notes": "Whore - BR",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive"
    },
    {
      "word": "rabo",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "rab0"
      ],
      "case_sensitive": false,
      "context_notes": "Tail, ass",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "rôla",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "rola",
        "r0la"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - BR",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "sacanagem",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "sacan@gem"
      ],
      "case_sensitive": false,
      "context_notes": "Dirty trick, debauchery",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "safado",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "safada",
        "saf@do"
      ],
      "case_sensitive": false,
      "context_notes": "Naughty, dirty - can be playful or severe",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "mild_to_moderate"
    },
    {
      "word": "sapatão",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "sapat@o",
        "sapatona"
      ],
      "case_sensitive": false,
      "context_notes": "Dyke, big shoe - lesbian slur",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "tarado",
      "severity": 2,
      "categories": [
        "derogatory",
        "sexual"
      ],
      "variations": [
        "tarada",
        "tar@do"
      ],
      "case_sensitive": false,
      "context_notes": "Pervert, sex maniac",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "traveco",
      "severity": 4,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "trav3co"
      ],
      "case_sensitive": false,
      "context_notes": "Tranny - extremely offensive transphobic slur",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "travesti",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory"
      ],
      "variations": [
        "trav3sti"
      ],
      "case_sensitive": false,
      "context_notes": "Transvestite, trans person - can be slur depending on context",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "moderate",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "moderate_to_strong_offense"
    },
    {
      "word": "trepar",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "trep@r"
      ],
      "case_sensitive": false,
      "context_notes": "To climb, to fuck",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "trouxa",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence"
      ],
      "variations": [
        "troux@"
      ],
      "case_sensitive": false,
      "context_notes": "Fool, sucker",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "vaca",
      "severity": 2,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "v@ca"
      ],
      "case_sensitive": false,
      "context_notes": "Cow, bitch",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "moderate_offense"
    },
    {
      "word": "vadia",
      "severity": 3,
      "categories": [
        "derogatory",
        "female_specific",
        "sexual"
      ],
      "variations": [
        "v@dia"
      ],
      "case_sensitive": false,
      "context_notes": "Slut, vagrant - feminine",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "vai se foder",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "vai se f*der",
        "vsf",
        "vai te foder"
      ],
      "case_sensitive": false,
      "context_notes": "Go fuck yourself - BR very common",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "moderate",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "vai tomar no cu",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "vtnc",
        "vai tomar no c*"
      ],
      "case_sensitive": false,
      "context_notes": "Go take it in the ass - BR signature phrase, extremely common",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "extremely_common",
        "pt_PT": "rare",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "veado",
      "severity": 3,
      "categories": [
        "lgbtq_slur",
        "derogatory",
        "male_specific"
      ],
      "variations": [
        "ve@do",
        "viadão",
        "viadinho"
      ],
      "case_sensitive": false,
      "context_notes": "Deer, faggot - BR homophobic slur",
      "target_type": "individual",
      "regional_usage": {
        "pt_BR": "very_common",
        "pt_PT": "rare",
        "pt_AO": "moderate",
        "pt_MZ": "moderate"
      },
      "formality_level": "highly_offensive_hate_speech"
    },
    {
      "word": "xana",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "x@na"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - PT",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "rare",
        "pt_PT": "very_common",
        "pt_AO": "common",
        "pt_MZ": "common"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "xexeca",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "x3xeca"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - BR",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "xibiu",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "xibi4"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - BR regional",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "xiri",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "xir1"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - BR regional",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "moderate",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    },
    {
      "word": "xota",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual",
        "female_specific"
      ],
      "variations": [
        "x0ta",
        "xoxota"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - BR variant",
      "target_type": "general",
      "regional_usage": {
        "pt_BR": "common",
        "pt_PT": "rare",
        "pt_AO": "rare",
        "pt_MZ": "rare"
      },
      "formality_level": "strong_offense"
    }
  ]
} as const

export type PTType = typeof PT
